<template>
  <div class="lang-switcher" v-if="enabled">
    <span class="lang-btn" :class="{ active: $i18n.locale === 'zh-CN' }" @click="switchTo('zh-CN')">中文</span>
    <span class="lang-divider">|</span>
    <span class="lang-btn" :class="{ active: $i18n.locale === 'en' }" @click="switchTo('en')">EN</span>
  </div>
</template>

<script>
import { LANG_SWITCHER_ENABLED } from '@/locale'

export default {
  name: 'LangSwitcher',
  data() {
    return {
      // 中英文切换开关（与 locale/index.js 共用，暂时关闭）
      enabled: LANG_SWITCHER_ENABLED,
    }
  },
  methods: {
    switchTo(locale) {
      this.$i18n.locale = locale
      localStorage.setItem('language', locale)
    },
  },
}
</script>

<style scoped>
.lang-switcher {
  display: flex;
  align-items: center;
  gap: 6px;
}

.lang-btn {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  cursor: pointer;
  padding: 3px 8px;
  border-radius: 4px;
  transition: all 0.2s;
  user-select: none;
}

.lang-btn:hover {
  color: rgba(255, 255, 255, 0.85);
}

.lang-btn.active {
  color: #fff;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.18);
}

.lang-divider {
  color: rgba(255, 255, 255, 0.25);
  font-size: 13px;
}
</style>
